module.exports = __webpack_public_path__ + "static/media/mdb.9ad9b77d.png";